import script from "./mobileBestSellingStar.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileBestSellingStar.vue?vue&type=script&setup=true&lang=js"

import "./mobileBestSellingStar.css?vue&type=style&index=0&id=6a21e378&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a21e378"]])

export default __exports__